import { useMemo, useCallback } from 'react';
import useAddCriteriaHandlers from './useAddCriteriaHandlers';
import useAddCriteriaMenu from './useAddCriteriaMenu';
import useAvailableCriteria from './useAvailableCriteria';

export const useSelectMoveTimeStep = ({ moveTimeData, onCriteriaChange }) => {
  const {
    handleCriteriaAdd,
    handleCriteriaRemove,
    handleCriterionChange
  } = useAddCriteriaHandlers({ moveTimeData, onCriteriaChange });

  const {
    menuAnchorEl,
    handleAddCriteriaClick,
    handleMenuClose
  } = useAddCriteriaMenu();

  const availableCriteriaTypes = useAvailableCriteria();

  const selectedTypes = useMemo(
    () => (moveTimeData.criteria || []).map(c => c.type),
    [moveTimeData.criteria]
  );

  const allCriteriaAdded = useMemo(
    () => selectedTypes.length >= availableCriteriaTypes.length,
    [selectedTypes.length, availableCriteriaTypes.length]
  );

  const createHandleRemove = useCallback(
    criterionId => () => handleCriteriaRemove(criterionId),
    [handleCriteriaRemove]
  );

  return {
    handleCriteriaAdd,
    handleCriterionChange,
    createHandleRemove,
    menuAnchorEl,
    handleAddCriteriaClick,
    handleMenuClose,
    selectedTypes,
    allCriteriaAdded
  };
};

export default useSelectMoveTimeStep;
